export const GET_JOBSEEKER = "GET_JOBSEEKER";
export const SINGLE_NOTIFICATION = "SINGLE_NOTIFICATION";
export const SECOND_NOTIFICATION = "SECOND_NOTIFICATION";
